// extracted by css-extract-rspack-plugin
export default {"cls1":"Results-cls1_fmd","cls2":"Results-cls2_VXO Results-cls1_fmd"};